(($) => {

  
 $(document).ready(function ($) {
   
 // FAQ and other accordions throughout site
 document.querySelectorAll('.cbfaq ').forEach(container => {
    container.querySelectorAll('.acc-item').forEach(item => {

        item.querySelector('.header').addEventListener('click', () => {
            container.querySelectorAll('.acc-item.active').forEach(item => {
                item.classList.remove('active');
            });
            item.classList.add('active');
        });
    });
 }); 

   
  document.querySelectorAll('.quick-add-wrapper').forEach(item => {
	new product_ProductModule(item)
  });
   
   document.querySelectorAll('.product-recommendations').forEach(section => {
     new MutationObserver(() => {
                          section.querySelectorAll('.quick-add-wrapper').forEach(item => {

		new product_ProductModule(item)
     })
                          }).observe(section, {childList: true});
   });
   
   


   /*
  if(!$('.custom_slant').length) {
    $('main').css('padding-top', '160px');
  }*/

	let testimonials = $('.testimonial-section');
      
    $(testimonials).flickity({
      lazyLoad: 2,
      autoPlay: 7000,
	  pauseAutoPlayOnHover: false,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(testimonials).on( 'settle.flickity', function() {
            $(testimonials).flickity('resize')
          });
        }
      }
    });
   
  let adjustCorals = () => {
		$('.coral-moved').remove();
  	  let count = 0;
      $(`[uk-parallax].overlap:not(.coral-moved)`).each(function() {
        count++;
    	let coral = $(this).clone();
        let container = $(this).closest('.shopify-section');
        
        $(this).css('visibility', 'hidden');
        coral.css('visibility', '');
        
    	coral.addClass('coral-moved');
		coral.attr('id', 'coral-'+count);
    	let offset = $(this).offset();
    
    	$('body').append(coral);
    
        coral.css({
            'top': offset.top+'px',
            'left': offset.left+'px',
            'position': 'absolute',
            'z-index': 3
        });
        if( container.width() < coral.offset().left+coral.width()) {
          let allowed = coral.width() - (coral.offset().left+coral.width()-container.width());

          let style = $('<style>');
          style.html(`
            #coral-${count} {
				/*clip-path: polygon(0 0, ${allowed}px 0, ${allowed}px ${coral.height()}px, 0 ${coral.height()}px);*/
				width: ${allowed}px !important;
            };
			`);
		  coral.append(style);
        }
      })

  }

  
// move all corals to higher z-index
    setTimeout(() => {
        adjustCorals();
    }, 500);
	$(window).on('resize', adjustCorals);


// patch to fix header sticky behavior after the dropdown/big menu is toggled 
    (() => {
        let header = document.querySelector('header');
        let isworking = false;
        new MutationObserver(() => {
            if(isworking) {
                return;
            }
            if(!header.classList.contains('active')) {
                isworking = true;
                header.classList.remove('absolute');
                setTimeout(() => { isworking = false}, 300);
            }
        }).observe(header, {attributeFilter: ['class']})
    })()

 }); // ready document
})(jQuery); // end 
